import "./footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <p className="body2">
          © 2024 | <span className="body2-underline">Coded</span> with ❤️️ by{" "}
          <span className="body2-medium">Nakqeeb</span>
        </p>
      </div>
    </div>
  );
};

export default Footer;
